export const GET_WORKFLOW_CHART_DATA = "fund/summary/";
